import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getMonth } from '@ifeng-fe/container_channel/common/client/winter/utils/formatTime';

class HeadContainer extends React.PureComponent {
    state = {
        dateValue: {
            day: new Date().getDate(),
            month: getMonth(),
            year: new Date().getFullYear(),
        },
    };

    static defaultProps = {
        animateConfig: {
            titleFix: false,
        },
    };
    static propTypes = {
        animateConfig: PropTypes.object,
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { animateConfig } = this.props;
        /**
         * 组件分发数据
         */

        return (
            <div className={animateConfig.titleFix ? styles.titleFix : styles.title}>
                <div className={styles.titleInner}>
                    <span>{this.state.dateValue.day}</span>
                    {this.state.dateValue.month}.{this.state.dateValue.year}
                </div>
            </div>
        );
    }
}

export default errorBoundary(HeadContainer);
